import { useState } from 'react';
import {
  TableRow,
  TableCell,
  Button,
  Icon,
  Typography,
} from '@safedns/skydns-ui-react-lib';

import DeleteADAgentModal from './DeleteADAgentModal';

import { useGetUserQuery, useGetProfilesQuery } from '../../services/ADapi';

import { getProfileName } from '../../utils/getProfileName';
import { formatDate } from '../../utils/formatDate.js';

import { actionTableCellStyle } from '../../styles/tableStyles';

import sprite from '../../icons/sprite.svg';

const UsersListItem = ({
  id,
  userName,
  collections,
  policy,
  pc,
  os,
  last_seen,
}) => {
  const {
    data: { user_id },
  } = useGetUserQuery();

  const { data: profilesList = [] } = useGetProfilesQuery(user_id);
  const [isDeleteAgentModalShow, setDeleteAgentModalState] = useState(false);

  const deleteADAgentModalStateHandler = () => {
    setDeleteAgentModalState((prevState) => !prevState);
  };

  return (
    <>
      <TableRow>
        <TableCell scope="row">{userName}</TableCell>
        <TableCell align="left">{collections}</TableCell>
        <TableCell align="left">
          {getProfileName(profilesList, policy)}
        </TableCell>
        <TableCell align="left">
          <Typography title={pc} ellipsis>
            {pc}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography title={os} ellipsis>
            {os}
          </Typography>
        </TableCell>
        <TableCell align="left">{formatDate(last_seen)}</TableCell>
        <TableCell sx={actionTableCellStyle}>
          <Button
            variant="icon"
            isIconButton
            onClick={deleteADAgentModalStateHandler}
          >
            <Icon id="remove" sprite={sprite} width={22} height={22} />
          </Button>
        </TableCell>
      </TableRow>
      {isDeleteAgentModalShow ? (
        <DeleteADAgentModal
          id={id}
          agentName={userName}
          onClose={deleteADAgentModalStateHandler}
        />
      ) : null}
    </>
  );
};

export default UsersListItem;
